import { getViemClients, } from "@bracket/contractor-next";

import {
	getContractWithABI,
	type ValidChainId,
} from "@bracket/chainography";

import type { Config } from "@wagmi/core";
import type { BlockHash } from "@bracket/types";

export declare type WethToBrktETHProps = {
	amount: bigint;
	brkt: bigint;
  config?: Config;
	chainId?: ValidChainId;
};

export declare type WethToBrktETHResult = {
	hash: BlockHash;
	brkt: bigint;
};



/**
 * Converts WETH to BRKTETH using the BrktETHRouter contract
 * @param {WethToBrktETHProps} props - The conversion parameters
 * @param {bigint} props.amount - The amount of WETH to convert
 * @param {bigint} props.brkt - The expected amount of BRKTETH to receive
 * @param {Config} [props.config] - Optional wagmi config
 * @param {ValidChainId} [props.chainId=1] - The chain ID to use (defaults to mainnet)
 * @returns {Promise<WethToBrktETHResult>} The transaction hash and actual BRKTETH amount received
 * @throws {Error} If the transaction fails
 */
export const wethToBrktETH = async ({
	amount,
	brkt,
  config,
	chainId = 1,
}: WethToBrktETHProps): Promise<WethToBrktETHResult> => {

  const [client, wclient] = await getViemClients({ chainId, config, });
  const [address, abi] = getContractWithABI("BrktETHRouter", chainId);

  try {
		const {
      request,
      result,
    } = await client.simulateContract({
			address,
      abi,
      functionName: "wethToBrktETH",
			args: [
        amount,
        BigInt(Number(brkt) * 0.9995),
      ],
			account: wclient.account,
		});

		const hash = await wclient.writeContract(request);
		await client.waitForTransactionReceipt({ hash });

		return {
			hash,
			brkt: result,
		};

  } catch (error) {

    throw new Error(`@bracket/chainography/brktETHRouter:wethToBrktETH has failed - ${error.message}`);
  }
};
